(function() {
    window.Station || (window.Station = {
        App: {
            config: {
                mediumScreen: 640,
                largeScreen: 1024
            }
        }
    }), window.Station.GrandCentral = {
        version: '1.2.11'
    }
}).call(this),
    function() {
        var $, closePanels, init, openPanel;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Accordions = ($ = jQuery.noConflict(), closePanels = function($accordion, animated) {
            var $openPanels;
            return void 0 === animated && (animated = !0), $openPanels = $('>dt.open', $accordion), animated ? $openPanels.removeClass('open').next('dd').velocity('slideUp', {
                duration: 400,
                easing: 'easeOutQuint',
                queue: !1,
                complete: function() {
                    return $accordion.data('locked', !1)
                }
            }) : $openPanels.removeClass('open').next('dd').hide(), !1
        }, openPanel = function($panel, animated) {
            var $accordion;
            return void 0 === animated && (animated = !0), $accordion = $panel.closest('.accordion'), $panel.addClass('open'), animated ? $panel.addClass('open').next('dd').velocity('slideDown', {
                duration: 400,
                easing: 'easeOutQuint',
                queue: !1,
                complete: function() {
                    return $accordion.data('locked', !1)
                }
            }) : $panel.next('dd').show(), !1
        }, init = function() {
            return $('.accordion').each((function(i) {
                var $openPanels, $panels, self;
                return self = this, $openPanels = ($panels = $('>dt', this)).filter('.open'), $(this).data('locked', !1), $openPanels.length && $openPanels.each((function() {
                    return openPanel($(this), !1)
                })), $panels.each((function() {
                    var $panel;
                    return $panel = $(this).closest('dt'), $('>a', this).on('click', (function(e) {
                        return e.preventDefault(), $(self).data('locked') || ($(self).data('locked', !0), $panel.hasClass('open') ? closePanels($(self)) : (closePanels($(self)), openPanel($panel))), !1
                    }))
                }))
            })), !1
        }, $(document).ready((function() {
            return init()
        })), {
            init: init,
            closePanels: closePanels,
            openPanel: openPanel
        })
    }.call(this),
    function() {
        var $, canPlayType, eCancel, eMove, eStart, isTouch, secondsToTime;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.AudioPlayer = ($ = jQuery.noConflict(), isTouch = 'ontouchstart' in window, eStart = isTouch ? 'touchstart' : 'mousedown', eMove = isTouch ? 'touchmove' : 'mousemove', eCancel = isTouch ? 'touchcancel' : 'mouseup', canPlayType = function(file) {
            var audioElement;
            return !(!(audioElement = document.createElement('audio')).canPlayType || !audioElement.canPlayType('audio/' + file.split('.').pop().toLowerCase() + ';').replace(/no/, ''))
        }, secondsToTime = function(secs) {
            var hours, hoursDiv, minutes, minutesDiv, seconds;
            return hoursDiv = secs / 3600, hours = Math.floor(hoursDiv), minutesDiv = secs % 3600 / 60, minutes = Math.floor(minutesDiv), (seconds = Math.ceil(secs % 3600 % 60)) > 59 && (seconds = 0, minutes = Math.ceil(minutesDiv)), minutes > 59 && (minutes = 0, hours = Math.ceil(hoursDiv)), (0 === hours ? '' : hours > 0 && hours.toString().length < 2 ? '0' + hours + ':' : hours + ':') + (minutes.toString().length < 2 ? '0' + minutes : minutes) + ':' + (seconds.toString().length < 2 ? '0' + seconds : seconds)
        }, $.fn.audioPlayer = function(params) {
            var cssClass, cssClassSub, subName;
            for (subName in params = $.extend({
                    classPrefix: 'audioplayer',
                    strPlay: 'Play',
                    strPause: 'Pause',
                    strVolume: 'Volume'
                }, params), cssClass = {}, cssClassSub = {
                    playPause: 'playpause',
                    playing: 'playing',
                    stopped: 'stopped',
                    time: 'time',
                    timeCurrent: 'time-current',
                    timeDuration: 'time-duration',
                    bar: 'bar',
                    barLoaded: 'bar-loaded',
                    barPlayed: 'bar-played',
                    volume: 'volume',
                    volumeButton: 'volume-button',
                    volumeAdjust: 'volume-adjust',
                    noVolume: 'novolume',
                    muted: 'muted',
                    mini: 'mini'
                }) cssClass[subName] = params.classPrefix + '-' + cssClassSub[subName];
            return this.each((function() {
                var $this, adjustCurrentTime, adjustVolume, audioFile, barLoaded, barPlayed, isAutoPlay, isLoop, isSupport, theAudio, theBar, thePlayer, timeCurrent, timeDuration, updateLoadBar, volumeAdjuster, volumeButton, volumeDefault, volumeTestDefault, volumeTestValue;
                if ('audio' !== $(this).prop('tagName').toLowerCase()) return !1;
                $this = $(this), audioFile = $this.attr('src'), isSupport = !1, isAutoPlay = '' === (isAutoPlay = $this.get(0).getAttribute('autoplay')) || 'autoplay' === isAutoPlay, isLoop = '' === (isLoop = $this.get(0).getAttribute('loop')) || 'loop' === isLoop, void 0 === audioFile ? $('source', $this).each((function() {
                    if (void 0 !== (audioFile = $(this).attr('src')) && canPlayType(audioFile)) return isSupport = !0, !1
                })) : canPlayType(audioFile) && (isSupport = !0), thePlayer = $('<div class="not-fitvid ' + params.classPrefix + '">' + (isSupport ? $('<div>').append($this.eq(0).clone()).html() : '<embed src="' + audioFile + '" width=0 height=0 volume=100 autostart="' + isAutoPlay.toString() + '" type="audio/mpeg" loop="' + isLoop.toString() + '" />') + '<div class="' + cssClass.playPause + '" title="' + params.strPlay + '"><a href="#">"' + params.strPlay + '"</a></div></div>'), theAudio = $(isSupport ? 'audio' : 'embed', thePlayer).get(0), isSupport ? (adjustCurrentTime = function(e) {
                    var theRealEvent;
                    theRealEvent = isTouch ? e.originalEvent.touches[0] : e, theAudio.currentTime = Math.round(theAudio.duration * (theRealEvent.pageX - theBar.offset().left) / theBar.width())
                }, adjustVolume = function(e) {
                    var theRealEvent;
                    theRealEvent = isTouch ? e.originalEvent.touches[0] : e, theAudio.volume = Math.abs((theRealEvent.pageY - (volumeAdjuster.offset().top + volumeAdjuster.height())) / volumeAdjuster.height())
                }, updateLoadBar = function() {
                    var interval;
                    interval = setInterval((function() {
                        if (theAudio.buffered.length < 1) return !0;
                        barLoaded.width(theAudio.buffered.end(0) / theAudio.duration * 100 + '%'), Math.floor(theAudio.buffered.end(0)) >= Math.floor(theAudio.duration) && clearInterval(interval)
                    }), 100)
                }, volumeDefault = 0, $('audio', thePlayer).css({
                    width: 0,
                    height: 0,
                    visibility: 'hidden'
                }), thePlayer.append('<div class="' + cssClass.time + ' ' + cssClass.timeCurrent + '"></div><div class="' + cssClass.bar + '"><div class="' + cssClass.barLoaded + '"></div><div class="' + cssClass.barPlayed + '"></div></div><div class="' + cssClass.time + ' ' + cssClass.timeDuration + '"></div><div class="' + cssClass.volume + '"><div class="' + cssClass.volumeButton + '" title="' + params.strVolume + '"><a href="#">"' + params.strVolume + '"</a></div><div class="' + cssClass.volumeAdjust + '"><div><div></div></div></div></div>'), theBar = $('.' + cssClass.bar, thePlayer), barPlayed = $('.' + cssClass.barPlayed, thePlayer), barLoaded = $('.' + cssClass.barLoaded, thePlayer), timeCurrent = $('.' + cssClass.timeCurrent, thePlayer), timeDuration = $('.' + cssClass.timeDuration, thePlayer), volumeButton = $('.' + cssClass.volumeButton, thePlayer), volumeAdjuster = $('.' + cssClass.volumeAdjust + ' > div', thePlayer), volumeTestDefault = theAudio.volume, volumeTestValue = theAudio.volume = .111, Math.round(1e3 * theAudio.volume) / 1e3 === volumeTestValue ? theAudio.volume = volumeTestDefault : thePlayer.addClass(cssClass.noVolume), timeDuration.html('&hellip;'), timeCurrent.html(secondsToTime(0)), theAudio.addEventListener('loadeddata', (function() {
                    updateLoadBar(), timeDuration.html($.isNumeric(theAudio.duration) ? secondsToTime(theAudio.duration) : '&hellip;'), volumeAdjuster.find('div').height(100 * theAudio.volume + '%'), volumeDefault = theAudio.volume
                })), theAudio.addEventListener('timeupdate', (function() {
                    timeCurrent.html(secondsToTime(theAudio.currentTime)), barPlayed.width(theAudio.currentTime / theAudio.duration * 100 + '%')
                })), theAudio.addEventListener('volumechange', (function() {
                    volumeAdjuster.find('div').height(100 * theAudio.volume + '%'), theAudio.volume > 0 && thePlayer.hasClass(cssClass.muted) && thePlayer.removeClass(cssClass.muted), theAudio.volume <= 0 && !thePlayer.hasClass(cssClass.muted) && thePlayer.addClass(cssClass.muted)
                })), theAudio.addEventListener('ended', (function() {
                    thePlayer.removeClass(cssClass.playing).addClass(cssClass.stopped)
                })), theBar.on(eStart, (function(e) {
                    adjustCurrentTime(e), theBar.on(eMove, (function(e) {
                        adjustCurrentTime(e)
                    }))
                })).on(eCancel, (function() {
                    theBar.unbind(eMove)
                })), volumeButton.on('click', (function() {
                    return thePlayer.hasClass(cssClass.muted) ? (thePlayer.removeClass(cssClass.muted), theAudio.volume = volumeDefault) : (thePlayer.addClass(cssClass.muted), volumeDefault = theAudio.volume, theAudio.volume = 0), !1
                })), volumeAdjuster.on(eStart, (function(e) {
                    adjustVolume(e), volumeAdjuster.on(eMove, (function(e) {
                        adjustVolume(e)
                    }))
                })).on(eCancel, (function() {
                    volumeAdjuster.unbind(eMove)
                }))) : thePlayer.addClass(cssClass.mini), thePlayer.addClass(isAutoPlay ? cssClass.playing : cssClass.stopped), $('.' + cssClass.playPause, thePlayer).on('click', (function() {
                    return thePlayer.hasClass(cssClass.playing) ? ($(this).attr('title', params.strPlay).find('a').html(params.strPlay), thePlayer.removeClass(cssClass.playing).addClass(cssClass.stopped), isSupport ? theAudio.pause() : theAudio.Stop()) : ($(this).attr('title', params.strPause).find('a').html(params.strPause), thePlayer.addClass(cssClass.playing).removeClass(cssClass.stopped), isSupport ? theAudio.play() : theAudio.Play()), !1
                })), $this.replaceWith(thePlayer)
            }))
        }, $(document).ready((function() {
            return $('audio').audioPlayer()
        })))
    }.call(this),
    function() {
        var $, closeNode, defaults, init, openNode, reset;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.NavPrimary = ($ = jQuery.noConflict(), defaults = {
            easing: 'easeOutCirc',
            nodeTransitionDuration: 300
        }, closeNode = function($node) {
            $node.closest('li').removeClass('nav-open').end().velocity('stop').velocity({
                height: 0
            }, {
                display: 'none',
                duration: defaults.nodeTransitionDuration,
                easing: defaults.easing,
                queue: !1
            })
        }, openNode = function($node) {
            $node.closest('li').addClass('nav-open').end().css({
                height: 'auto'
            }).velocity('stop').velocity({
                height: [$node.outerHeight(), 0]
            }, {
                display: 'block',
                duration: defaults.nodeTransitionDuration,
                easing: defaults.easing,
                queue: !1,
                complete: function() {
                    $(this).css('height', 'auto')
                }
            })
        }, reset = function() {
            $('.nav-primary').each((function() {
                return $('ul', this).removeAttr('style'), $('.nav-open', this).removeClass('nav-open')
            }))
        }, init = function() {
            $('.nav-primary').each((function() {
                var $nodes, $rootNode, $toggleSelector, navID, self;
                self = this, navID = $(this).data('nav-id'), $nodes = $('ul', this), $rootNode = $('> ul', this).first(), $toggleSelector = $('.nav-toggle[data-nav-id=\'' + navID + '\']'), $nodes.each((function() {
                    var level, node;
                    return node = this, level = parseInt($(this).parentsUntil(self, 'ul').length + 1), $(this).addClass('nav-level-' + level).closest('li').addClass('nav-node').attr('aria-haspopup', !0).children(':first-child').on('mouseover', (function(e) {
                        return e.stopPropagation()
                    })).on('click', (function(e) {
                        var isEmptyLink, isOpen;
                        isEmptyLink = '' === $(this).attr('href') || '#' === $(this).attr('href'), isOpen = $(node).closest('li').hasClass('nav-open'), 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ? !0 !== $(this).data('nav-item-touched') ? (e.preventDefault(), $(this).data('nav-item-touched', !0), openNode($(node))) : !isEmptyLink && isOpen || (e.preventDefault(), $(this).data('nav-item-touched', !1), closeNode($(node))) : 'small' === Station.GrandCentral.Utilities.screenSize() && (isEmptyLink ? (e.preventDefault(), isOpen ? closeNode($(node)) : openNode($(node))) : !0 !== $(this).data('nav-item-touched') ? (e.preventDefault(), $(this).data('nav-item-touched', !0), openNode($(node))) : !isEmptyLink && isOpen || (e.preventDefault(), $(this).data('nav-item-touched', !1), closeNode($(node))))
                    }))
                })), $toggleSelector.on('click', (function(e) {
                    return $rootNode.hasClass('nav-open') ? ($(this).removeClass('nav-open'), $rootNode.removeClass('nav-open'), closeNode($rootNode)) : ($(this).addClass('nav-open'), $rootNode.addClass('nav-open'), openNode($rootNode))
                }))
            }))
        }, $(document).ready((function() {
            var windowWidth;
            return windowWidth = $(window).width(), init(), $(window).on('resize', (function() {
                if ($(window).width() !== windowWidth) return windowWidth = $(window).width(), reset()
            }))
        })), {
            init: init,
            closeNode: closeNode,
            openNode: openNode,
            reset: reset
        })
    }.call(this),
    function() {
        var $, closeKinNodes, closeNode, defaults, init, openNode, toggleNode;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.NavSide = ($ = jQuery.noConflict(), defaults = {
            closeKin: !1,
            easingKin: 'easeInOutCirc',
            easing: 'easeOutCirc',
            nodeTransitionDuration: 300
        }, closeKinNodes = function($node) {
            var duration;
            duration = $node.closest('.nav-side').data('node-transition-duration'), $node.closest('li').siblings('.nav-open').find('ul').each((function() {
                closeNode($(this), duration, !0)
            }))
        }, closeNode = function($node, nodeTransitionDuration, closeKin) {
            nodeTransitionDuration = void 0 !== nodeTransitionDuration ? nodeTransitionDuration : defaults.nodeTransitionDuration, $node.closest('li').removeClass('nav-open'), nodeTransitionDuration > 0 ? $node.velocity('stop').velocity({
                height: 0
            }, {
                display: 'none',
                duration: nodeTransitionDuration,
                easing: closeKin ? defaults.easingKin : defaults.easing,
                queue: !1
            }) : $node.css({
                height: 0
            }).hide()
        }, openNode = function($node, nodeTransitionDuration, closeKin) {
            nodeTransitionDuration = void 0 !== nodeTransitionDuration ? nodeTransitionDuration : defaults.nodeTransitionDuration, closeKin = void 0 !== closeKin ? closeKin : defaults.closeKin, $node.closest('li').addClass('nav-open').end().css({
                height: 'auto'
            }), nodeTransitionDuration > 0 ? $node.velocity('stop').velocity({
                height: [$node.outerHeight(), 0]
            }, {
                display: 'block',
                duration: nodeTransitionDuration,
                easing: closeKin ? defaults.easingKin : defaults.easing,
                queue: !1,
                complete: function() {
                    $(this).css('height', 'auto')
                }
            }) : $node.show(), closeKin && closeKinNodes($node)
        }, toggleNode = function($node, nodeTransitionDuration, closeKin) {
            nodeTransitionDuration = void 0 !== nodeTransitionDuration ? nodeTransitionDuration : defaults.nodeTransitionDuration, closeKin = void 0 !== closeKin ? closeKin : defaults.closeKin, $node.closest('li').hasClass('nav-open') ? closeNode($node, nodeTransitionDuration, closeKin) : openNode($node, nodeTransitionDuration, closeKin)
        }, init = function() {
            return $('.nav-side').each((function() {
                var $nodes, closeKin, expanded, nodeTransitionDuration, rootNode;
                rootNode = this, closeKin = $(this).data('close-kin'), expanded = $(this).data('expanded'), nodeTransitionDuration = $(this).data('node-transition-duration'), $nodes = $('ul', this), $(this).addClass('nav-level-1'), $nodes.each((function() {
                    var $openNodes, level, node;
                    if (node = this, level = parseInt($(this).parentsUntil(rootNode, 'ul').length + 2), $(this).addClass('nav-level-' + level), expanded && $(this).closest('li').addClass('nav-open').end().css({
                            height: 'auto',
                            display: 'block'
                        }), $(this).closest('li').addClass('nav-node').children(':first-child').on('click', (function(e) {
                            var isEmptyLink, isOpen;
                            isEmptyLink = '' === $(this).attr('href') || '#' === $(this).attr('href'), isOpen = $(node).closest('li').hasClass('nav-open'), 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ? !0 !== $(this).data('nav-item-touched') ? (e.preventDefault(), $(this).data('nav-item-touched', !0), toggleNode($(node), nodeTransitionDuration, closeKin)) : isOpen && isEmptyLink && (e.preventDefault(), $(this).data('nav-item-touched', !1), toggleNode($(node), nodeTransitionDuration, closeKin)) : !isEmptyLink && isOpen || (e.preventDefault(), toggleNode($(node), nodeTransitionDuration, closeKin))
                        })), $(this).closest('li').hasClass('nav-open')) return ($openNodes = $(node).parentsUntil(rootNode, 'ul')).push($(node)), $openNodes.each((function() {
                        return openNode($(this), 0, !1)
                    }))
                }))
            }))
        }, $(document).ready((function() {
            return init()
        })), {
            init: init,
            closeNode: closeNode,
            openNode: openNode,
            toggleNode: toggleNode
        })
    }.call(this),
    function() {
        var $, $nb, close, init, nbTimeout, open;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Notify = ($ = jQuery.noConflict(), nbTimeout = '', $nb = {}, init = function() {
            return $('body').prepend('<div id="notify-bar"><div class="message"></div><a href="#" class="close" data-close>&times;</div>'), ($nb = $('#notify-bar')).hide()
        }, close = function() {
            return $nb.hasClass('inline') ? $nb.velocity({
                'margin-top': -$nb.outerHeight()
            }, {
                duration: 200,
                easing: 'easeInExpo',
                queue: !1,
                complete: function() {
                    return $nb.hide().find('.message').html('')
                }
            }) : $nb.velocity({
                translateY: '-100%'
            }, {
                duration: 200,
                easing: 'easeInExpo',
                queue: !1,
                complete: function() {
                    return clearTimeout(nbTimeout), $nb.removeAttr('style').hide().find('.message').html('')
                }
            })
        }, open = function(message, type, duration, sticky, inline, showTime) {
            if (type || (type = 'slate'), duration || (duration = 6e3), sticky || (sticky = !1), inline || (inline = !1), showTime || (showTime = !1), clearTimeout(nbTimeout), $('.message', $nb).html(message), $('.timer', $nb).remove(), $nb.removeClass('inline').removeAttr('style').attr('class', type), $('a[data-close]', $nb).on('click', (function(e) {
                    return e.preventDefault(), close()
                })), inline ? $nb.addClass('inline').show().velocity({
                    'margin-top': [0, -$nb.outerHeight()]
                }, {
                    duration: 300,
                    easing: 'easeOutCirc',
                    queue: !1
                }) : $nb.show().velocity({
                    translateY: [0, '-100%']
                }, {
                    duration: 300,
                    easing: 'easeOutCirc',
                    queue: !1
                }), !sticky && (nbTimeout = setTimeout(close, duration), showTime)) return $('<div>').addClass('timer').prependTo($nb).velocity({
                width: ['100%', 0]
            }, {
                duration: duration,
                easing: 'linear',
                queue: !1
            })
        }, $(document).ready((function() {
            return init()
        })), $(document).on('keydown', (function(e) {
            27 === e.keyCode && close()
        })), {
            init: init,
            close: close,
            open: open
        })
    }.call(this),
    function() {
        var $, closeTabs, init, openTab;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Tabs = ($ = jQuery.noConflict(), openTab = function($tab) {
            if (!$tab.hasClass('open')) return $tab.addClass('open')
        }, closeTabs = function(tabs) {
            return $('.tab.open', tabs).removeClass('open')
        }, init = function() {
            return $('.tabs').each((function(i) {
                var self;
                return self = this, $('.tab.open', this).length || openTab($('.tab', this).first()), $(this).on('click', '.tab-title', (function(e) {
                    var $tab;
                    if ($tab = $(this).closest('.tab'), e.preventDefault(), !$tab.hasClass('open')) return closeTabs(self), openTab($tab)
                }))
            }))
        }, $(document).ready((function() {
            return init()
        })), {
            init: init,
            closeTabs: closeTabs,
            openTab: openTab
        })
    }.call(this),
    function() {
        var $, _locationHash, _locationSearch, _newState, _replaceState, _urlParam, arraysEqual, config, delay, getParam, msieVersion, onAjaxError, removeProtocol, screenSize, setParam, switchElement;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Utilities = ($ = jQuery.noConflict(), config = Station.App.config, $.fn.randomize = function(selector) {
            return (selector ? this.find(selector) : this).parent().each((function() {
                return $(this).children(selector).sort((function() {
                    return Math.random() - .5
                }))
            }))
        }, $.fn.randomizeInPlace = function(selector) {
            return (selector ? this.find(selector) : this).parent().each((function() {
                return $(this).children(selector).sort((function() {
                    return Math.random() - .5
                })).detach().appendTo(this)
            }))
        }, arraysEqual = function(a, b) {
            if ('object' == typeof a && 'object' == typeof b) return a.length === b.length && a.every((function(elem, i) {
                return elem === b[i]
            }))
        }, delay = function(ms, func) {
            return setTimeout(func, ms)
        }, getParam = function(param) {
            var m, pattern;
            return pattern = new RegExp('[?&]' + param + '((=([^&]*))|(?=(&|$)))', 'i'), (m = window.location.search.match(pattern)) && (void 0 === m[3] ? '' : m[3])
        }, msieVersion = function() {
            var msie, ua;
            return (msie = (ua = window.navigator.userAgent).indexOf('MSIE ')) > 0 && parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)))
        }, onAjaxError = function(XMLHttpRequest, textStatus, showError, message) {
            var response, responseMessage;
            return responseMessage = (response = $.parseJSON(XMLHttpRequest.responseText)).message + ': ' + response.description, message || (message = responseMessage), console.log(textStatus), console.log(response)
        }, removeProtocol = function(e) {
            return e.replace(/http(s)?:/, '')
        }, screenSize = function() {
            var queryMedium, querySmall;
            return querySmall = 'screen and (max-width: ' + config.mediumScreen + 'px)', queryMedium = 'screen and (min-width: ' + config.mediumScreen + 'px) and (max-width: ' + config.largeScreen + 'px)', window.matchMedia(querySmall).matches ? 'small' : window.matchMedia(queryMedium).matches ? 'medium' : 'large'
        }, setParam = function(e, t) {
            window.history && window.history.replaceState && _replaceState(_newState(e, t))
        }, switchElement = function(hide, show, addClass) {
            var $show;
            ($show = $(show)) && ($(hide).hide(), $show.addClass(addClass).show())
        }, _locationSearch = function() {
            return window.location.search
        }, _locationHash = function() {
            return window.location.hash
        }, _newState = function(e, t) {
            return (_urlParam(e) ? _locationSearch().replace(RegExp('(' + e + '=)[^&#]+'), '$1' + t) : '' === _locationSearch() ? '?' + e + '=' + t : _locationSearch() + '&' + e + '=' + t) + _locationHash()
        }, _replaceState = function(e) {
            window.history.replaceState({}, document.title, e)
        }, _urlParam = function(e) {
            var t;
            return (t = RegExp('[?&]' + e + '=([^&#]*)').exec(_locationSearch())) && decodeURIComponent(t[1].replace(/\+/g, ' '))
        }, $('[data-target-new]').attr('target', '_blank'), $('[data-click-history-back]').on('click', (function() {
            return window.history.back(), !1
        })), $('[data-auto-focus]').focus(), $('form:not([html-validate])').attr('novalidate', ''), {
            arraysEqual: arraysEqual,
            delay: delay,
            getParam: getParam,
            msieVersion: msieVersion,
            onAjaxError: onAjaxError,
            removeProtocol: removeProtocol,
            screenSize: screenSize,
            setParam: setParam,
            switchElement: switchElement
        })
    }.call(this),
    function() {
        var $, buildCustomTransitions, init, setDefaults;
        Station.GrandCentral.Vendor = Station.GrandCentral.Vendor || {}, Station.GrandCentral.Vendor.FancyBox = ($ = jQuery.noConflict(), buildCustomTransitions = function(F) {
            F.transitions.grandCentralIn = function() {
                F.wrap.velocity({
                    opacity: [1, 0],
                    translateY: [0, -20]
                }, {
                    duration: F.current.openSpeed,
                    easing: F.current.openEasing,
                    complete: F._afterZoomIn
                })
            }, F.transitions.grandCentralOut = function() {
                F.wrap.removeClass('fancybox-opened').velocity({
                    opacity: 0,
                    translateY: -20
                }, {
                    duration: F.current.closeSpeed,
                    easing: F.current.closeEasing,
                    complete: function() {
                        return F._afterZoomOut()
                    }
                })
            }, F.transitions.grandCentralChangeIn = function() {
                var direction, tX, tY;
                'left' === (direction = F.direction) && (tX = [0, 60], tY = 0), 'right' === direction && (tX = [0, -60], tY = 0), 'up' === direction && (tX = 0, tY = [0, 60]), 'down' === direction && (tX = 0, tY = [0, -60]), F.wrap.velocity({
                    opacity: [1, 0],
                    translateX: tX,
                    translateY: tY
                }, {
                    duration: F.current.nextSpeed,
                    easing: F.current.nextEasing,
                    complete: F._afterZoomIn
                })
            }, F.transitions.grandCentralChangeOut = function() {
                var direction, tX, tY;
                'left' === (direction = F.direction) && (tX = -60, tY = 0), 'right' === direction && (tX = 60, tY = 0), 'up' === direction && (tX = 0, tY = -60), 'down' === direction && (tX = 0, tY = 60), F.previous.wrap.velocity({
                    opacity: 0,
                    translateX: tX,
                    translateY: tY
                }, {
                    duration: F.current.prevSpeed,
                    easing: F.previous.easing,
                    complete: function() {
                        return $(this).trigger('onReset').remove()
                    }
                })
            }
        }, setDefaults = function() {
            return $.extend($.fancybox.defaults, {
                closeBtn: !1,
                closeEasing: 'easeInCirc',
                closeMethod: 'grandCentralOut',
                closeSpeed: 200,
                nextEasing: 'easeInOutCirc',
                nextMethod: 'grandCentralChangeIn',
                nextSpeed: 300,
                openEasing: 'easeOutCirc',
                openMethod: 'grandCentralIn',
                openSpeed: 500,
                padding: 0,
                prevEasing: 'easeInOutCirc',
                prevMethod: 'grandCentralChangeOut',
                prevSpeed: 300,
                wrapCSS: 'fancybox-grand-central',
                helpers: {
                    overlay: {
                        css: {
                            background: 'rgba(255, 255, 255, 0.94)'
                        }
                    },
                    title: {
                        type: 'inside'
                    },
                    media: {}
                },
                beforeLoad: function() {
                    var height, width;
                    if (height = parseInt(this.element.data('fancybox-height')), (width = parseInt(this.element.data('fancybox-width'))) && (this.width = width), height) return this.height = height
                },
                afterLoad: function() {
                    $('.fancybox-overlay').addClass(this.wrapCSS)
                },
                afterShow: function() {
                    $('[data-modal-close]', this.inner).on('click', (function(e) {
                        return e.preventDefault(), $.fancybox.close()
                    })), $('.fancybox-overlay > .fancybox-close-wrap').length || 'modal' !== this.element.data('modal-type') && $('<div class="fancybox-close-wrap" />').html('<div class="fancybox-close"><i class="fa fa-close"></div>').prependTo($('.fancybox-overlay')).on('click', (function(e) {
                        return e.preventDefault(), $.fancybox.close()
                    })), $('.fancybox-nav', this.wrap).length && ($('.fancybox-overlay > .fancybox-nav-prev-wrap').length || ($('<div class="fancybox-nav-prev-wrap" />').html('<div class="fancybox-nav-prev"><i class="fa fa-caret-left"></div>').prependTo($('.fancybox-overlay')).on('click', (function() {
                        return $.fancybox.prev()
                    })), $('<div class="fancybox-nav-next-wrap" />').html('<div class="fancybox-nav-next"><i class="fa fa-caret-right"></div>').prependTo($('.fancybox-overlay')).on('click', (function() {
                        return $.fancybox.next()
                    }))), this.wrap.hasClass('fancybox-type-ajax') && $('.fancybox-nav', this.outer).hide())
                },
                beforeClose: function() {
                    $('.fancybox-overlay').addClass('fancybox-closing')
                }
            })
        }, init = function() {
            return $('.fancybox').fancybox(), $('.fancybox[data-modal-type="modal"]').fancybox({
                modal: !0
            })
        }, $(document).ready((function() {
            if ('function' == typeof jQuery.fn.fancybox) return buildCustomTransitions(jQuery.fancybox), setDefaults(), init()
        })))
    }.call(this),
    function() {
        var $, cache, cacheElements, config, init, initCarousel, initCarousels, selectors;
        Station.GrandCentral.Vendor = Station.GrandCentral.Vendor || {}, Station.GrandCentral.Vendor.Flickity = ($ = jQuery.noConflict(), selectors = {
            attr: {
                options: 'data-flickity-options'
            },
            carousel: '.gc-carousel'
        }, config = {
            defaultOptions: {
                arrowShape: 'M65.0491632,29.3794051 C66.0536287,28.3749397 66.0536287,26.7677949 65.0491632,25.7633294 L58.3795124,19.0936786 C57.3750469,18.0892131 55.7679022,18.0892131 54.7634367,19.0936786 L24.9509011,48.9062141 C23.9464357,49.9106796 23.9464357,51.5178244 24.9509011,52.5222899 L54.7634367,82.3348254 C55.7679022,83.3392909 57.3750469,83.3392909 58.3795124,82.3348254 L65.0491632,75.6651746 C66.0536287,74.6607091 66.0536287,73.0535643 65.0491632,72.0490989 L43.7143164,50.714252 L65.0491632,29.3794051 Z',
                autoPlay: 5e3,
                cellAlign: 'center',
                cellSelector: '.gc-carousel-cell',
                contain: !0,
                draggable: !0,
                freeScroll: !1,
                freeScrollFriction: .03,
                friction: .28,
                initialIndex: 0,
                lazyLoad: 1,
                pauseAutoPlayOnHover: !0,
                pageDots: !0,
                prevNextButtons: !0,
                selectedAttraction: .025,
                wrapAround: !0
            }
        }, cache = {}, init = function() {
            cacheElements(), initCarousels()
        }, cacheElements = function() {
            cache = {
                $carousels: $(selectors.carousel)
            }
        }, initCarousels = function() {
            cache.$carousels.length && cache.$carousels.each((function() {
                return initCarousel($(this))
            }))
        }, initCarousel = function($carousel, options) {
            var inlineOptions;
            null == options && (options = {}), (inlineOptions = $carousel.attr('data-flickity-options')) && (inlineOptions = JSON.parse(inlineOptions)), options = $.extend(config.defaultOptions, inlineOptions, options), $carousel.flickity(options)
        }, $((function() {
            init()
        })), {
            init: init,
            cacheElements: cacheElements,
            initCarousel: initCarousel,
            initCarousels: initCarousels
        })
    }.call(this),
    function() {
        var $, addClassTo, cache, cacheElements, init, initFitVids, initJumpMenus, initShopifyExtensions, initSlideSideMenu, initStickyCart, initStickyHeader, removeClassFrom, selectors, setPageTitle;
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Base = ($ = jQuery.noConflict(), selectors = {
            shopifySectionHeader: '#shopify-section-header',
            announcementBar: '#announcement-bar',
            appHeader: '#app-header',
            appUpperHeader: '#app-upper-header',
            appLowerHeader: '#app-lower-header',
            slideSideMenu: '#slide-side-menu',
            slideOutSideMenu: '#slide-out-side-menu',
            slideInSideMenu: '#slide-in-side-menu',
            stickyCart: '#sticky-cart',
            pageTitle: '.page-header .title',
            appBody: '#app-body',
            overlayBackground: '#overlay-background'
        }, Station.Theme.config, cache = {}, addClassTo = function($element, className) {
            $element.hasClass(className) || $element.addClass(className)
        }, removeClassFrom = function($element, className) {
            $element.hasClass(className) && $element.removeClass(className)
        }, init = function() {
            return cacheElements(), initStickyHeader(), initSlideSideMenu(), initStickyCart(), initShopifyExtensions(), initFitVids(), initJumpMenus()
        }, cacheElements = function() {
            return cache = {
                $shopifySectionHeader: $(selectors.shopifySectionHeader),
                $announcementBar: $(selectors.announcementBar),
                $appHeader: $(selectors.appHeader),
                $appUpperHeader: $(selectors.appUpperHeader),
                $appLowerHeader: $(selectors.appLowerHeader),
                $slideSideMenu: $(selectors.slideSideMenu),
                $slideOutSideMenu: $(selectors.slideOutSideMenu),
                $slideInSideMenu: $(selectors.slideInSideMenu),
                $stickyCart: $(selectors.stickyCart),
                $pageTitle: $(selectors.pageTitle),
                $appBody: $(selectors.appBody),
                $overlayBackground: $(selectors.overlayBackground)
            }
        }, initStickyHeader = function() {
            var st0, top;
            cache.$appHeader.hasClass('sticky-on') && !cache.$appHeader.hasClass('sticky-off') && (top = cache.$announcementBar.outerHeight() || 0, st0 = 0, cache.$appBody.css({
                'padding-top': cache.$appUpperHeader.outerHeight() + cache.$appLowerHeader.outerHeight()
            }), $(window).on('resize orientationchange', (function(e) {
                top = cache.$announcementBar.outerHeight() || 0, cache.$appBody.css({
                    'padding-top': cache.$appUpperHeader.outerHeight() + cache.$appLowerHeader.outerHeight()
                })
            })), $(window).scroll((function(e) {
                var st1;
                (st1 = $(this).scrollTop()) >= top ? addClassTo(cache.$appHeader, 'sticky') : removeClassFrom(cache.$appHeader, 'sticky'), Math.abs(st1 - st0) >= 100 && (st1 > st0 ? addClassTo(cache.$appLowerHeader, 'idle') : removeClassFrom(cache.$appLowerHeader, 'idle'), st0 = st1)
            })))
        }, initSlideSideMenu = function() {
            cache.$slideOutSideMenu.click((function(e) {
                addClassTo(cache.$overlayBackground, 'active'), addClassTo(cache.$slideSideMenu, 'active')
            })), cache.$slideInSideMenu.click((function(e) {
                removeClassFrom(cache.$slideSideMenu, 'active'), removeClassFrom(cache.$overlayBackground, 'active')
            })), cache.$overlayBackground.click((function(e) {
                removeClassFrom(cache.$slideSideMenu, 'active'), removeClassFrom($(this), 'active')
            })), cache.$slideSideMenu.find('li.collapsible').each((function() {
                $(this).one('click', (function(e) {
                    e.preventDefault(), $(this).addClass('collapsed').children('ul').slideDown(300)
                }))
            }))
        }, initStickyCart = function() {
            cache.$stickyCart.hasClass('top') && cache.$appHeader.hasClass('sticky-on') ? (cache.$stickyCart.css({
                'box-shadow': 'none'
            }), cache.$stickyCart.children('.sticky-cart-content').css({
                height: cache.$appUpperHeader.outerHeight() - 20
            }), $(window).on('resize orientationchange', (function(e) {
                cache.$stickyCart.children('.sticky-cart-content').css({
                    height: cache.$appUpperHeader.outerHeight() - 20
                })
            }))) : cache.$stickyCart.css({
                'box-shadow': '0 0 2px rgba(0,0,0, 0.2)'
            }), $(window).scroll((function(e) {
                $(this).scrollTop() >= cache.$shopifySectionHeader.outerHeight() ? addClassTo(cache.$stickyCart, 'active') : removeClassFrom(cache.$stickyCart, 'active')
            }))
        }, initFitVids = function() {
            'function' == typeof $.fn.fitVids && $('.fit-video').fitVids()
        }, initJumpMenus = function() {
            return $('select.jump-menu').change((function() {
                window.location = $('option:selected', this).val()
            }))
        }, initShopifyExtensions = function() {
            var aCouples, aKeyValue, i;
            if (Shopify.queryParams = {}, location.search.length)
                for (aKeyValue = void 0, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length;)(aKeyValue = aCouples[i].split('=')).length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1])), i++
        }, setPageTitle = function(text) {
            null == text && (text = cache.$pageTitle.data('default-text')), cache.$pageTitle.text(text)
        }, $(window).resize((function() {
            clearTimeout(window.resizedFinished), window.resizedFinished = setTimeout((function() {
                Station.Theme.Collection.alignRows()
            }), 100)
        })), $((function() {
            init()
        })), {
            init: init,
            initStickyHeader: initStickyHeader,
            initSlideSideMenu: initSlideSideMenu,
            initStickyCart: initStickyCart,
            initFitVids: initFitVids,
            initJumpMenus: initJumpMenus,
            initShopifyExtensions: initShopifyExtensions,
            cacheElements: cacheElements,
            setPageTitle: setPageTitle
        })
    }.call(this),
    function() {
        var $, _initAddToCartButtons, addToCart, cache, cacheElements, config, init, lineItemAddedConfirmationMessage, selectors, updateCartTotals;
        Station.Theme = Station.Theme || {}, Station.Theme.Cart = ($ = jQuery.noConflict(), selectors = {
            attr: {
                cartAction: 'data-cart-action'
            },
            addToCart: '.add-to-cart',
            addToCartForm: 'form[action^=/cart/add]',
            cartBadge: '.cart-badge'
        }, Station.Theme.current, Station.Theme.config, config = {
            i18n: Station.Theme.i18n,
            notify: Station.GrandCentral.Notify
        }, cache = {}, init = function(container) {
            return cacheElements(), _initAddToCartButtons()
        }, cacheElements = function() {
            return cache = {
                $addToCart: $(selectors.addToCart),
                $cartBadge: $(selectors.cartBadge)
            }
        }, addToCart = function(action, triggerElement) {
            var $triggerElement, serializedForm;
            if (action || triggerElement) switch (serializedForm = ($triggerElement = $(triggerElement)).closest(selectors.addToCartForm).serialize(), action) {
                case 'notification':
                    $triggerElement.blur(), $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: serializedForm,
                        dataType: 'json',
                        success: function(item) {
                            updateCartTotals(), config.notify.open(lineItemAddedConfirmationMessage(item), 'success')
                        },
                        error: function(XMLHttpRequest, textStatus) {
                            var responseText;
                            responseText = JSON.parse(XMLHttpRequest.responseText), config.notify.open(responseText.description, 'error')
                        }
                    });
                    break;
                default:
                    return
            }
        }, lineItemAddedConfirmationMessage = function(item) {
            var viewCartLink;
            return viewCartLink = '<div class="actions"><a class="button small" href="/cart">' + config.i18n.cart.notification.viewCartLink + '</a></div>', config.i18n.cart.notification.productAdded.replace('{{ product_title }}', item.title).replace('{{ view_cart_link }}', viewCartLink)
        }, updateCartTotals = function() {
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(data) {
                    var count, itemCountText;
                    switch (data.item_count) {
                        case 0:
                            count = 'zero';
                            break;
                        case 1:
                            count = 'one';
                            break;
                        default:
                            count = 'other'
                    }
                    return itemCountText = config.i18n.cart.itemCount[count].replace('{{ count }}', data.item_count), $('.cart-item-count').html(data.item_count), $('.cart-item-count-items').html(itemCountText), $('.cart-total-price').html(Station.Theme.Currency.formatMoney(data.total_price)), data.item_count > 0 ? cache.$cartBadge.removeClass('empty') : cache.$cartBadge.addClass('empty')
                }
            })
        }, _initAddToCartButtons = function() {
            cache.$addToCart.each((function() {

                $(this)
                    .off('click.stationCart')
                    .on('click.stationCart', (function(e) {

                        var action;

                        switch (action = $(this).attr(selectors.attr.cartAction)) {

                            case 'notification':

                                e.preventDefault();
                                e.stopImmediatePropagation();

                                $(this).blur();

                                addToCart(action, this);

                                return false;
                        }

                    }));

            }));
        }, $((function() {
            init()
        })), {
            init: init,
            addToCart: addToCart
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionListSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.CollectionListSection.prototype = _.assignIn({}, Station.Theme.CollectionListSection.prototype, jQuery, {
            onSelect: function(evt) {
                Station.Theme.Collection.alignRows()
            }
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.CollectionSection.prototype = _.assignIn({}, Station.Theme.CollectionSection.prototype, jQuery, {
            onSelect: function(evt) {
                return Station.Theme.Cart.init(), Station.Theme.Collection.init(), Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionTemplateSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.CollectionTemplateSection.prototype = _.assignIn({}, Station.Theme.CollectionTemplateSection.prototype, jQuery, {
            onLoad: function(evt) {
                Station.Theme.Cart.init()
            },
            onSelect: function(evt) {
                return Station.Theme.Cart.init(), Station.Theme.Collection.init(), Station.Theme.Currency.init()
            },
            onBlockSelect: function(evt) {
                Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        var $, alignRows, cache, cacheElements, init, initSortMenus, selectors;
        Station.Theme = Station.Theme || {}, Station.Theme.Collection = ($ = jQuery.noConflict(), selectors = {
            listCollections: '.list-collections',
            products: '.collection-products',
            sectionCollectionList: '.section-collection-list',
            sortBy: 'select.sort-collection-by'
        }, Station.Theme.config, cache = {}, init = function() {
            cacheElements(), initSortMenus(), alignRows()
        }, cacheElements = function() {
            cache = {
                $listCollections: $(selectors.listCollections),
                $products: $(selectors.products),
                $sectionCollectionList: $(selectors.sectionCollectionList),
                $sortBy: $(selectors.sortBy)
            }
        }, alignRows = function() {
            'function' == typeof $.fn.matchHeight && (cache.$products.length && ($(selectors.products + ' .image-container').matchHeight(), $(selectors.products + ' .title-wrap').matchHeight(), $(selectors.products + ' .pricing').matchHeight()), cache.$listCollections.length && ($('.collection-grid-item .image-container').matchHeight(), $('.collection-title').matchHeight()), cache.$sectionCollectionList.length && ($('.collection-grid-item .image-container').matchHeight(), $('.collection-title').matchHeight()))
        }, initSortMenus = function() {
            cache.$sortBy.length && cache.$sortBy.each((function() {
                var $this, sortBy;
                sortBy = ($this = $(this)).attr('data-sort-by'), $(this).val(sortBy).on('change', (function() {
                    Shopify.queryParams.sort_by = $this.val(), location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20')
                }))
            }))
        }, $((function() {
            init()
        })), {
            init: init,
            cacheElements: cacheElements,
            alignRows: alignRows,
            initSortMenus: initSortMenus
        })
    }.call(this),
    function() {
        var $, _bindEvents, cache, cacheElements, config, convertAll, formatMoney, init, renderPrice, selectors, setCurrency, themeConfig;
        Station.Theme = Station.Theme || {}, Station.Theme.Currency = ($ = jQuery.noConflict(), selectors = {
            attr: {
                basePrice: 'data-base-price'
            },
            currencyCode: '[data-currency-code]',
            currencySelect: '[data-currency-selector]',
            singleOptionSelector: '[name="id"][data-option-selector]',
            price: '[data-price]'
        }, themeConfig = Station.Theme.config, config = {
            currentCurrency: Station.Theme.current.currency,
            moneyFormat: Station.Theme.shop.moneyFormat,
            moneyWithCurrencyFormat: Station.Theme.shop.moneyWithCurrencyFormat,
            shop: Station.Theme.shop,
            shopCurrency: Station.Theme.shop.currency
        }, cache = {}, init = function() {
            var currency;
            cacheElements(), _bindEvents(), Currency.moneyFormats[config.shopCurrency].money_format = config.moneyFormat, Currency.moneyFormats[config.shopCurrency].money_with_currency_format = config.moneyWithCurrencyFormat, currency = themeConfig.enableMultiCurrency && themeConfig.defaultCurrency ? themeConfig.defaultCurrency : config.shopCurrency, themeConfig.enableMultiCurrency && Currency.cookie.read() && (currency = Currency.cookie.read()), Currency.currentCurrency = currency, setCurrency(currency)
        }, cacheElements = function() {
            return cache = {
                $currencyCode: $(selectors.currencyCode),
                $currencySelect: $(selectors.currencySelect),
                $price: $(selectors.price),
                $singleOptionSelector: $(selectors.singleOptionSelector)
            }
        }, convertAll = function(currency) {
            null == currency && (currency = Currency.currentCurrency), cache.$price.each((function() {
                return renderPrice(this, $(this).attr(selectors.attr.basePrice), '', currency)
            })), $('option', cache.$singleOptionSelector).each((function() {
                var amount, hasPrice, text;
                hasPrice = (text = (text = $(this).html()).substr(0, text.lastIndexOf('—') + 2)).lastIndexOf('—') > 0, amount = $(this).attr(selectors.attr.basePrice), hasPrice && (amount = amount ? formatMoney(amount, null, currency) : Station.Theme.i18n.product.soldOut, $(this).html(text + amount))
            }))
        }, formatMoney = function(amount, style, currency) {
            var format, formattedAmount;
            if (!isNaN(parseInt(amount))) return amount = amount ? parseInt(amount) : 0, currency = currency || Currency.currentCurrency, style = style || themeConfig.moneyStyle, format = Currency.moneyFormats[currency][style], formattedAmount = Currency.convert(amount, config.shopCurrency, currency), Currency.formatMoney(formattedAmount, format)
        }, renderPrice = function(element, amount, style, currency) {
            var $e, formattedAmount, manualStyle;
            'money_format' !== (manualStyle = ($e = $(element)).attr('data-money-style')) && 'money_with_currency_format' !== manualStyle || (style = manualStyle), isNaN(parseInt(amount)) ? (formattedAmount = amount, amount = '') : formattedAmount = formatMoney(amount, style, currency), $e.attr(selectors.attr.basePrice, amount).html(formattedAmount).addClass('converted')
        }, setCurrency = function(currency) {
            cache.$currencyCode.html(currency), cache.$currencySelect.val(currency), Currency.currentCurrency = currency, Currency.cookie.write(currency), convertAll(currency)
        }, _bindEvents = function() {
            cache.$currencySelect.on('change', (function() {
                return setCurrency($(this).val())
            }))
        }, $((function() {
            'object' == typeof Currency && init()
        })), {
            init: init,
            cacheElements: cacheElements,
            convertAll: convertAll,
            formatMoney: formatMoney,
            renderPrice: renderPrice,
            setCurrency: setCurrency
        })
    }.call(this),
    function() {
        var $, Addresses, config, _bindEvents, cache, cacheElements, deleteAddress, hideAddressForm, init, initCountryProvinceSelector, initCountryProvinceSelectors, selectors, showAddressForm, showAddressFormsWithErrors, toggleAddress;
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Customer = ($ = jQuery.noConflict(), config = {
            addressesTemplate: 'customers/addresses',
            loginTemplate: 'customers/login'
        }, Station.Theme.config, selectors = {
            addAddress: '#add_address',
            addAddressButton: '[data-form-id="add_address"]:first',
            customerAddress: '.customer-address',
            customerAddressForm: '.customer-address form',
            deleteAddress: '.delete-address',
            editAddress: '[id^="edit_address"]',
            errors: '.errors',
            toggleAddress: '.toggle-address'
        }, cache = {}, init = function() {
            return cacheElements(), _bindEvents(), initCountryProvinceSelectors(), showAddressFormsWithErrors()
        }, cacheElements = function() {
            cache = {
                $addAddressButton: $(selectors.addAddressButton),
                $pageHeaderTitle: $(selectors.pageHeaderTitle),
                $customerAddress: $(selectors.customerAddress),
                $customerAddressForm: $(selectors.customerAddressForm),
                $deleteAddress: $(selectors.deleteAddress),
                $toggleAddress: $(selectors.toggleAddress)
            }
        }, deleteAddress = function(id, confirmMessage) {
            confirm(confirmMessage) && Shopify.postLink('/account/addresses/' + id, {
                parameters: {
                    _method: 'delete'
                }
            })
        }, hideAddressForm = function($form) {
            $form.hide()
        }, initCountryProvinceSelector = function(id) {
            return new Shopify.CountryProvinceSelector('address_country_' + id, 'address_province_' + id, {
                hideElement: 'address_province_row_' + id
            })
        }, initCountryProvinceSelectors = function() {
            Shopify && initCountryProvinceSelector('new'), cache.$customerAddress.not(selectors.addAddress).each((function() {
                var id;
                if (id = $(this).attr('id').replace('address_', ''), Shopify) return initCountryProvinceSelector(id)
            }))
        }, showAddressForm = function($form, $scrollToElement) {
            $form.show().addClass('animate-in fade-in-down'), $scrollToElement && $scrollToElement.length && $scrollToElement.velocity('scroll', {
                duration: 500,
                offset: -20,
                easing: 'easeInOutCirc'
            }), Station.GrandCentral.Utilities.delay(20, (function() {
                return $('input[type="text"]', $form).first().focus()
            }))
        }, showAddressFormsWithErrors = function() {
            return cache.$customerAddressForm.each((function() {
                var $form;
                $form = $(this).closest(selectors.addAddress, selectors.editAddress), $(selectors.errors, $(this)).length && showAddressForm($form, $form)
            }))
        }, toggleAddress = function(id, $scrollToElement) {
            var $form;
            ($form = $(id)).length && ($form.is(':visible') ? (hideAddressForm($form), id === selectors.addAddress && (Station.Theme.Base.setPageTitle(), cache.$addAddressButton.show())) : (id === selectors.addAddress && ($scrollToElement = $('#content-wrap'), cache.$addAddressButton.hide(), Station.Theme.Base.setPageTitle(cache.$addAddressButton.text())), showAddressForm($form, $scrollToElement)))
        }, _bindEvents = function() {
            return cache.$toggleAddress.on('click', (function(e) {
                e.preventDefault(), $(this).blur(), toggleAddress('#' + $(this).data('form-id'), $(this))
            })), cache.$deleteAddress.on('click', (function(e) {
                e.preventDefault(), $(this).blur(), deleteAddress($(this).data('form-id'), $(this).data('confirm-message'))
            }))
        }, Station.Theme.current.templateType === config.addressesTemplate && init(), Addresses = {
            init: init,
            cacheElements: cacheElements,
            deleteAddress: deleteAddress,
            hideAddressForm: hideAddressForm,
            initCountryProvinceSelector: initCountryProvinceSelector,
            initCountryProvinceSelectors: initCountryProvinceSelectors,
            showAddressForm: showAddressForm,
            showAddressFormsWithErrors: showAddressFormsWithErrors,
            toggleAddress: toggleAddress
        }, {
            Login: function() {
                var _bindEvents, cache, cacheElements, init, renderRecoverPasswordSuccess, selectors, setInitialSection;
                return selectors = {
                    loginSection: '#customer-login',
                    recoverPasswordSection: '#customer-recover-password',
                    recoverPasswordSuccess: '[data-recover-password-success]',
                    recoverPasswordSuccessTest: '#recover-password-success',
                    togglePasswordRecovery: '.toggle-password-recovery'
                }, cache = {}, init = function() {
                    return cacheElements(), _bindEvents(), setInitialSection(), renderRecoverPasswordSuccess(cache.$recoverPasswordSuccess.length)
                }, cacheElements = function() {
                    cache = {
                        $loginSection: $(selectors.loginSection),
                        $recoverPasswordSection: $(selectors.recoverPasswordSection),
                        $recoverPasswordSuccess: $(selectors.recoverPasswordSuccess),
                        $recoverPasswordSuccessTest: $(selectors.recoverPasswordSuccessTest),
                        $togglePasswordRecovery: $(selectors.togglePasswordRecovery)
                    }
                }, renderRecoverPasswordSuccess = function(visible) {
                    visible && cache.$recoverPasswordSuccessTest.show().removeClass('hidden')
                }, setInitialSection = function() {
                    var section;
                    section = '#recover' === window.location.hash ? selectors.recoverPasswordSection : selectors.loginSection, Station.GrandCentral.Utilities.switchElement(selectors.loginSection + ', ' + selectors.recoverPasswordSection, section)
                }, _bindEvents = function() {
                    return cache.$togglePasswordRecovery.on('click', (function(e) {
                        e.preventDefault(), Station.GrandCentral.Utilities.switchElement(selectors.loginSection + ', ' + selectors.recoverPasswordSection, '#' + $(this).data('show-module-id'), 'animate-in fade-in-down')
                    }))
                }, $((function() {
                    Station.Theme.current.templateType === config.loginTemplate && init()
                })), {
                    init: init,
                    cacheElements: cacheElements,
                    renderRecoverPasswordSuccess: renderRecoverPasswordSuccess,
                    setInitialSection: setInitialSection
                }
            }(),
            Addresses: Addresses
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.FooterSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.FooterSection.prototype = _.assignIn({}, Station.Theme.FooterSection.prototype, jQuery, {
            onSelect: function(evt) {
                Station.GrandCentral.Accordions.init(), Station.GrandCentral.NavSide.init(), Station.GrandCentral.Notify.init(), Station.GrandCentral.Tabs.init(), 'object' == typeof twttr && twttr.widgets.load()
            },
            onBlockSelect: function(evt) {
                Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.HeaderSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.HeaderSection.prototype = _.assignIn({}, Station.Theme.HeaderSection.prototype, jQuery, {
            onSelect: function(evt) {
                Station.GrandCentral.NavPrimary.init()
            }
        })
    }.call(this),
    function() {
        var $, Product, current, init, setZoom, themeConfig;
        Station.Theme = Station.Theme || {}, Station.Theme.Image = ($ = jQuery.noConflict(), current = Station.Theme.current, themeConfig = Station.Theme.config, Product = function() {
            var _getSecondaryImageContainer, _getVariantByImageID, _resetPrimaryImage, _setActiveSecondaryImage, _updatePrimaryImage, cache, cacheElements, init, initPrimaryImage, initSecondaryImages, selectors, update;
            return selectors = {
                primaryImage: '.primary-image',
                primaryImageContainer: '.primary-image-container',
                primaryImageSection: '.primary-images',
                secondaryImage: '.secondary-image',
                secondaryImageContainer: '.secondary-image-container'
            }, cache = {}, init = function() {
                switch (cacheElements(), current.templateType) {
                    case 'product':
                        initPrimaryImage(), initSecondaryImages()
                }
            }, initPrimaryImage = function($imageContainer) {
                var $image, $seconaryImageContainer, imageID, imageIndex;
                $imageContainer || ($imageContainer = $(selectors.primaryImageContainer + ':first-child', cache.$primaryImageSection)), imageID = $imageContainer.attr('data-image-id'), $seconaryImageContainer = _getSecondaryImageContainer(imageID), imageIndex = cache.$secondaryImageContainers.index($seconaryImageContainer), $image = $('img:first', $imageContainer), $('a:first', $imageContainer).attr('target', '_blank'), _setActiveSecondaryImage($seconaryImageContainer), cache.$primaryImageSection.is('[is-zoomable]') && setZoom($imageContainer, $image.attr('data-src-master')), $imageContainer.on('click', (function(e) {
                    var group, options;
                    if (themeConfig.product.enableLightbox) return e.preventDefault(), cache.$secondaryImageContainers.length ? (group = $('a:first', cache.$secondaryImageContainers), options = {
                        index: imageIndex
                    }) : group = $('a:first', $imageContainer), $.fancybox(group, options)
                }))
            }, initSecondaryImages = function() {
                cache.$secondaryImageContainers.each((function() {
                    var $si, $siLink, $this, imageID, variant;
                    return $this = $(this), $si = $(selectors.secondaryImage, $this), $siLink = $('a:first', $this), imageID = $si.attr('data-image-id'), variant = _getVariantByImageID(imageID), $siLink.on('click', (function(e) {
                        return e.preventDefault(), _setActiveSecondaryImage($this), variant && themeConfig.product.enableSetVariantFromSecondary ? Station.Theme.Product.setVariantByID(variant.id, themeConfig.product.enableDeepLinking) : _updatePrimaryImage($this)
                    }))
                }))
            }, update = function(variant) {
                var $imageContainer;
                variant ? ('string' != typeof variant && 'number' != typeof variant || (variant = Station.Theme.Product.getVariantByID(parseInt(variant))), 'object' == typeof variant && variant.featured_image ? ($imageContainer = _getSecondaryImageContainer(variant.featured_image.id)) && _updatePrimaryImage($imageContainer) : _resetPrimaryImage()) : _resetPrimaryImage()
            }, _getSecondaryImageContainer = function(imageID) {
                var container, containerImageID, i, len, ref;
                for (i = 0, len = (ref = cache.$secondaryImageContainers).length; i < len; i++)
                    if (container = ref[i], (containerImageID = $(container).attr('data-image-id')) && imageID && parseInt(containerImageID) === parseInt(imageID)) return $(container);
                return !1
            }, _getVariantByImageID = function(imageID) {
                var i, len, ref, variant;
                for (i = 0, len = (ref = current.product.variants).length; i < len; i++)
                    if ((variant = ref[i]).featured_image && variant.featured_image.id && parseInt(variant.featured_image.id) === parseInt(imageID)) return variant;
                return !1
            }, _resetPrimaryImage = function() {
                var $imageContainer, featuredImageID;
                $imageContainer = (featuredImageID = Station.Theme.current.featuredImageID) ? _getSecondaryImageContainer(featuredImageID) : $(cache.$secondaryImageContainers).first(), _updatePrimaryImage($imageContainer)
            }, _setActiveSecondaryImage = function($imageContainer) {
                cache.$secondaryImageContainers.removeClass('active'), $imageContainer && $imageContainer.addClass('active')
            }, _updatePrimaryImage = function($imageContainer) {
                var $newPI, $newPIContainer, $pi, $piContainer, newImageID;
                $imageContainer && (newImageID = $imageContainer.attr('data-image-id'), ($newPIContainer = $(selectors.primaryImageContainer + '[data-image-id="' + newImageID + '"]', cache.$primaryImageSection)).length ? ($(selectors.primaryImageContainer, cache.$primaryImageSection).hide(), $newPIContainer.show()) : ($piContainer = $(selectors.primaryImageContainer, cache.$primaryImageSection), $pi = $('img:first', $piContainer), $newPIContainer = $imageContainer.clone(), $newPI = $('img:first', $newPIContainer), $newPIContainer.attr('class', $piContainer.attr('class')), $newPI.attr('class', $pi.attr('class')).addClass('lazyload'), $(selectors.primaryImageContainer, cache.$primaryImageSection).hide(), $(cache.$primaryImageSection).prepend($newPIContainer), initPrimaryImage($newPIContainer)), _setActiveSecondaryImage($imageContainer), cache.$primaryImageSection.is('[is-zoomable]') && setZoom(cache.$newPIContainer, $('img:first', $newPIContainer).attr('data-src-master')))
            }, {
                init: init,
                initSecondaryImages: initSecondaryImages,
                cacheElements: cacheElements = function() {
                    cache = {
                        $primaryImageSection: $(selectors.primaryImageSection),
                        $secondaryImageContainers: $(selectors.secondaryImageContainer)
                    }
                },
                update: update
            }
        }(), init = function() {
            return Product.init()
        }, setZoom = function($e, src) {
            $e && ($($e).trigger('zoom.destroy'), $e.zoom({
                url: src,
                touch: !1,
                duration: 0,
                callback: function() {
                    return this.naturalWidth <= $e.parent().width() ? $e.css('width', this.naturalWidth + 'px') : $e.css('width', 'initial'), this.naturalHeight <= $e.parent().height() ? $e.css('height', this.naturalHeight + 'px') : $e.css('height', 'initial')
                }
            }))
        }, $((function() {
            init()
        })), {
            Product: Product,
            setZoom: setZoom
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.MapSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id'), this.$map = $('.google-map', this.$container)
            }
        }(jQuery.noConflict()), Station.Theme.MapSection.prototype = _.assignIn({}, Station.Theme.MapSection.prototype, jQuery, {
            onUnload: function(evt) {
                void 0 !== window.google && google.maps.event.clearListeners(this.map, 'resize')
            },
            onSelect: function(evt) {
                Station.Theme.Map.loadMap(this.$map)
            }
        })
    }.call(this),
    function() {
        var $, cache, cacheElements, config, createMap, geolocate, init, loadMap, loadMaps, selectors, showMapError;
        Station.Theme = Station.Theme || {}, Station.Theme.Map = ($ = jQuery.noConflict(), selectors = {
            maps: '.google-map'
        }, Station.Theme.config, config = {
            i18n: Station.Theme.i18n,
            scriptURL: 'https://maps.googleapis.com/maps/api/js?key=',
            zoom: 14
        }, cache = {}, init = function() {
            cacheElements(), loadMaps()
        }, cacheElements = function() {
            cache = {
                $maps: $(selectors.maps)
            }
        }, createMap = function(map) {
            var $map;
            $map = $(map), cache.$currentMapContainer = $map, geolocate($map).then(function(results) {
                var center, mapOptions;
                mapOptions = {
                    zoom: config.zoom,
                    styles: config.styles,
                    center: results[0].geometry.location,
                    draggable: !1,
                    clickableIcons: !1,
                    scrollwheel: !1,
                    disableDoubleClickZoom: !0,
                    disableDefaultUI: !0
                }, map = new google.maps.Map($map[0], mapOptions), center = map.getCenter(), new google.maps.Marker({
                    map: map,
                    position: center
                }), google.maps.event.addDomListener(window, 'resize', (function() {
                    google.maps.event.trigger(map, 'resize'), map.setCenter(center)
                }))
            }.bind(this)).fail((function() {
                var errorMessage;
                switch (errorMessage = void 0, $map.geocoderStatus) {
                    case 'ZERO_RESULTS':
                        errorMessage = config.i18n.map.errors.addressNoResults;
                        break;
                    case 'OVER_QUERY_LIMIT':
                        errorMessage = config.i18n.map.errors.addressQueryLimitHTML;
                        break;
                    default:
                        errorMessage = config.i18n.map.errors.addressError
                }
                showMapError(errorMessage)
            }))
        }, geolocate = function($map) {
            var address, deferred, geocoder;
            return deferred = $.Deferred(), geocoder = new google.maps.Geocoder, address = $map.data('address'), geocoder.geocode({
                address: address
            }, (function(results, status) {
                status !== google.maps.GeocoderStatus.OK && ($map.geocoderStatus = status, deferred.reject(status)), deferred.resolve(results)
            })), deferred
        }, loadMap = function(map) {
            var $map;
            ($map = $(map)).key = $map.data('api-key'), 'string' == typeof $map.key && '' !== $map.key && (0 === $('script[src*="' + $map.key + '&"]').length ? $.getScript(config.scriptURL + $map.key).then((function() {
                createMap(map)
            })) : createMap(map))
        }, loadMaps = function() {
            cache.$maps.each((function(i) {
                return loadMap(this)
            }))
        }, showMapError = function(errorMessage, $map) {
            var errorElement;
            $map || ($map = cache.$currentMapContainer), $map && (errorElement = '<div class="errors map-errors text-center">' + errorMessage + '</div>', $map.html(errorElement))
        }, window.gm_authFailure = function() {
            Shopify.designMode && showMapError(config.i18n.map.errors.authErrorHTML)
        }, $((function() {
            init()
        })), {
            init: init,
            cacheElements: cacheElements,
            loadMap: loadMap,
            loadMaps: loadMaps,
            showMapError: showMapError
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.PasswordTemplateSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.PasswordTemplateSection.prototype = _.assignIn({}, Station.Theme.PasswordTemplateSection.prototype, jQuery, {
            onSelect: function(evt) {
                Station.Theme.Password.init()
            }
        })
    }.call(this),
    function() {
        var $, _bindEvents, cache, cacheElements, init, selectors, showPasswordEntry, showPasswordNotice;
        Station.Theme = Station.Theme || {}, Station.Theme.Password = ($ = jQuery.noConflict(), selectors = {
            page: 'html.password',
            pageModule: 'html.password .password-module',
            enterLink: 'html.password .enter-link',
            cancelEnterLink: 'html.password .cancel-enter-link',
            input: 'html.password input#password',
            emailInput: 'html.password input#email',
            moduleLogin: '#password-entry',
            moduleNotice: '#opening-soon'
        }, Station.Theme.config, cache = {}, init = function() {
            cacheElements(), _bindEvents(), 'password' === Station.Theme.current.templateType && ($('.errors', selectors.moduleLogin).length && showPasswordEntry(), cache.$enterLink.first().on('click', (function() {
                showPasswordEntry()
            })), cache.$cancelEnterLink.first().on('click', (function() {
                showPasswordNotice()
            })))
        }, showPasswordEntry = function() {
            Station.GrandCentral.Utilities.switchElement(selectors.pageModule, '#' + cache.$enterLink.data('show-module-id'), 'animate-in fade-in-down'), cache.$enterLink.hide(), cache.$cancelEnterLink.show(), cache.$input.focus()
        }, showPasswordNotice = function() {
            Station.GrandCentral.Utilities.switchElement(selectors.pageModule, '#' + cache.$cancelEnterLink.data('show-module-id'), 'animate-in fade-in-down'), cache.$cancelEnterLink.hide(), cache.$enterLink.show(), cache.$emailInput.focus()
        }, cacheElements = function() {
            cache = {
                $cancelEnterLink: $(selectors.cancelEnterLink),
                $enterLink: $(selectors.enterLink),
                $input: $(selectors.input),
                $emailInput: $(selectors.emailInput),
                $page: $(selectors.page)
            }
        }, _bindEvents = function() {
            $(document).keyup((function(e) {
                27 === e.keyCode && showPasswordNotice()
            }))
        }, $((function() {
            init()
        })), {
            init: init,
            cacheElements: cacheElements
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.ProductTemplateSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.ProductTemplateSection.prototype = _.assignIn({}, Station.Theme.ProductTemplateSection.prototype, jQuery, {
            onSelect: function(evt) {
                Station.Theme.Cart.init(), Station.Theme.Image.Product.init(), Station.Theme.Product.init()
            }
        })
    }.call(this),
    function() {
        var $, _initOptionSelectors, _initQtySync, _initSelectAnOption, _initVariant, cache, cacheElements, config, current, enableQtyLimit, getVariantByID, getVariantBySelectors, init, isOnBackorder, selectors, setAddToCartButtons, setBackorderNotice, setCompareAtPrice, setQtyAvailable, setSale, setSelectAnOption, setSku, setSmartPaymentButtons, setVariant, setVariantByID, setVariantID, themeConfig;
        Station.Theme = Station.Theme || {}, Station.Theme.Product = ($ = jQuery.noConflict(), selectors = {
            addToCart: '#shopify-section-product-template .add-to-cart',
            basePrice: '#shopify-section-product-template [data-base-price]',
            backorderNotice: '#shopify-section-product-template .backorder-notice',
            currency: '#shopify-section-product-template [data-currency]',
            currencyCode: '#shopify-section-product-template [data-currency-code]',
            from: '#shopify-section-product-template .from',
            optionSelector: '#shopify-section-product-template [data-option-selector]',
            stickyCartOptionSelector: '.sticky-cart-option-selector',
            price: '#shopify-section-product-template [data-price]',
            priceCompareAt: '#shopify-section-product-template .compare-at',
            priceSell: '#shopify-section-product-template .sell-price',
            qty: '#shopify-section-product-template .quantity',
            qtyAvailable: '#shopify-section-product-template [data-quantity-available]',
            saleSticker: '#shopify-section-product-template .sale-sticker',
            sku: '#shopify-section-product-template [data-sku]:not(option)',
            smartPaymentButtonContainer: '.smart-payment-button-container',
            variantID: 'input[name="id"]'
        }, current = Station.Theme.current, themeConfig = Station.Theme.config, config = {
            i18n: Station.Theme.i18n,
            currentCurrency: current.currency,
            currentProduct: current.product,
            currentVariant: current.variant,
            renderPrice: Station.Theme.Currency.renderPrice,
            shop: Station.Theme.shop,
            templateType: current.templateType,
            utilities: Station.GrandCentral.Utilities
        }, cache = {}, init = function(container) {
            if (cacheElements(), 'product' === config.templateType && (_initOptionSelectors(), _initVariant(), _initSelectAnOption(), _initQtySync()), themeConfig.product.enableQtyLimit) return enableQtyLimit()
        }, cacheElements = function() {
            return cache = {
                $addToCart: $(selectors.addToCart),
                $basePrice: $(selectors.basePrice),
                $backorderNotice: $(selectors.backorderNotice),
                $currency: $(selectors.currency),
                $currencyCode: $(selectors.currencyCode),
                $from: $(selectors.from),
                $optionSelector: $(selectors.optionSelector),
                $stickyCartOptionSelector: $(selectors.stickyCartOptionSelector),
                $price: $(selectors.price),
                $priceCompareAt: $(selectors.priceCompareAt),
                $priceSell: $(selectors.priceSell),
                $qty: $(selectors.qty),
                $qtyAvailable: $(selectors.qtyAvailable),
                $saleSticker: $(selectors.saleSticker),
                $sku: $(selectors.sku),
                $smartPaymentButtonContainer: $(selectors.smartPaymentButtonContainer),
                $variantID: $(selectors.variantID)
            }
        }, getVariantByID = function(id) {
            var variant;
            return variant = null, $.each(config.currentProduct.variants, (function(i, e) {
                if (e.id === parseInt(id)) return variant = e, !1
            })), variant
        }, getVariantBySelectors = function(product, $optionSelector) {
            var options, variant, variants;
            return null == $optionSelector && ($optionSelector = cache.$optionSelector), options = [], variant = null, variants = product ? product.variants : config.currentProduct.variants, $optionSelector.each((function() {
                var position;
                return position = parseInt($(this).data('option-number')), options.splice(position, 0, $('option:selected', this).text())
            })), $.each(variants, (function(i, e) {
                if (Station.GrandCentral.Utilities.arraysEqual(options, e.options)) return variant = e, !1
            })), variant
        }, isOnBackorder = function(variant) {
            return 'continue' === variant.inventory_policy && variant.inventory_quantity <= 0
        }, enableQtyLimit = function(max, min) {
            min = min > 0 ? min : 1, max = max < 0 ? 0 : max, cache.$qty.each((function() {
                var $this;
                return ($this = $(this)).attr('min', min), $this.attr('max', max), 0 === max && $this.removeAttr('max'), $this.on('change', (function() {
                    var val;
                    return min = parseInt($this.attr('min')), max = parseInt($this.attr('max')), val = parseInt($this.val()), 0 === max && (val = 0), val <= min && (val = min), val >= max && (val = max), $this.val(val)
                })), $(this).trigger('change')
            }))
        }, setAddToCartButtons = function(text, enabled) {
            text || (text = enabled ? config.i18n.product.addToCart : config.i18n.product.soldOut), cache.$addToCart.text(text), enabled ? cache.$addToCart.prop('disabled', !1).removeClass('disabled') : cache.$addToCart.prop('disabled', !0).addClass('disabled')
        }, setSmartPaymentButtons = function(visible) {
            !1 === visible ? cache.$smartPaymentButtonContainer.addClass('hidden') : cache.$smartPaymentButtonContainer.removeClass('hidden')
        }, setBackorderNotice = function(html, visible) {
            html && cache.$backorderNotice.html(html), !1 === visible ? cache.$backorderNotice.addClass('hidden') : cache.$backorderNotice.removeClass('hidden')
        }, setCompareAtPrice = function(html, visible) {
            html && cache.$priceCompareAt.html(html), !1 === visible ? cache.$priceCompareAt.addClass('hidden') : cache.$priceCompareAt.removeClass('hidden')
        }, setQtyAvailable = function(qty, visible) {
            qty < 0 && (qty = 0), cache.$qtyAvailable.text(qty), !1 === visible ? cache.$qtyAvailable.parent().hide() : cache.$qtyAvailable.parent().show()
        }, setSale = function(sale) {
            (sale = 'boolean' == typeof sale ? sale : sale.compare_at_price > sale.price) ? (cache.$saleSticker.removeClass('hidden'), themeConfig.product.enableHighlightAddWhenSale && cache.$addToCart.addClass('focus')) : (cache.$saleSticker.addClass('hidden'), cache.$addToCart.removeClass('focus'))
        }, setSelectAnOption = function() {
            cache.$optionSelector.each((function() {
                var text;
                if (!$(this).val()) return text = $('option:selected', $(this)).text(), cache.$priceSell.text(text), setAddToCartButtons(text), !1
            }))
        }, setSku = function(sku, visible) {
            cache.$sku.text(sku), !1 === visible ? cache.$sku.parent().hide() : cache.$sku.parent().show()
        }, setVariant = function(variant, deepLink) {
            variant ? (current.variant = variant, setVariantID(), config.renderPrice(selectors.priceSell, variant.price), config.renderPrice(selectors.priceCompareAt, variant.compare_at_price), setCompareAtPrice(null, variant.compare_at_price > variant.price), setQtyAvailable(variant.inventory_quantity), setSku(variant.sku), setSale(variant), setBackorderNotice(null, isOnBackorder(variant)), setAddToCartButtons('', variant.available), setSmartPaymentButtons(variant.available), Station.Theme.Image.Product.update(variant.id), themeConfig.product.enableQtyLimit && enableQtyLimit(variant.inventory_quantity), deepLink && config.utilities.setParam('variant', variant.id)) : (current.variant = null, setVariantID(), config.renderPrice(selectors.priceSell, config.i18n.product.unavailable), config.renderPrice(selectors.priceCompareAt), setCompareAtPrice(null, !1), setQtyAvailable(0), setSku('', !1), setSale(!1), setBackorderNotice(null, !1), setAddToCartButtons(config.i18n.product.unavailable, !1), setSmartPaymentButtons(!1), Station.Theme.Image.Product.update(), themeConfig.product.enableQtyLimit && enableQtyLimit(0, 0)), setSelectAnOption()
        }, setVariantID = function(id, $element) {
            id || (id = null !== current.variant ? current.variant.id : ''), $element || ($element = cache.$variantID), $element.val(id)
        }, setVariantByID = function(id, deepLink) {
            var variant;
            id && (variant = getVariantByID(id)) && (cache.$optionSelector.each((function(index, value) {
                $(this).val(variant['option' + (index + 1)])
            })), setVariant(variant, deepLink))
        }, _initOptionSelectors = function() {
            cache.$optionSelector.each((function() {
                return $(this).on('change', (function() {
                    var variant;
                    return cache.$stickyCartOptionSelector.filter('[data-option-number=' + $(this).data('option-number') + ']').val($(this).val()), variant = getVariantBySelectors(config.currentProduct, cache.$optionSelector), setVariant(variant, themeConfig.product.enableDeepLinking)
                }))
            })), cache.$stickyCartOptionSelector.each((function() {
                return $(this).on('change', (function() {
                    var sync;
                    return (sync = cache.$optionSelector.filter('[data-option-number=' + $(this).data('option-number') + ']')).val($(this).val()), sync.trigger('change')
                }))
            }))
        }, _initSelectAnOption = function() {
            themeConfig.product.enableSelectAnOption && (cache.$optionSelector.each((function(index, value) {
                var $selectedOption, optionName;
                return null == (optionName = $(this).data('select-text')) && (optionName = currentProduct.options[index]), $selectedOption = '<option value="">' + optionName + '</option>', $(this).prepend($selectedOption).val('')
            })), cache.$optionSelector.first().trigger('change'))
        }, _initVariant = function() {
            var variantID;
            (variantID = Station.GrandCentral.Utilities.getParam('variant')) && (config.currentVariant = getVariantByID(variantID)), setVariant(config.currentVariant, !1), themeConfig.product.showPrimaryImageFirst && !variantID && Station.Theme.Image.Product.update()
        }, _initQtySync = function() {
            cache.$qty.each((function() {
                return $(this).on('change', (function() {
                    return cache.$qty.val($(this).val())
                }))
            }))
        }, $((function() {
            init()
        })), {
            init: init,
            cacheElements: cacheElements,
            getVariantByID: getVariantByID,
            getVariantBySelectors: getVariantBySelectors,
            isOnBackorder: isOnBackorder,
            enableQtyLimit: enableQtyLimit,
            setAddToCartButtons: setAddToCartButtons,
            setBackorderNotice: setBackorderNotice,
            setCompareAtPrice: setCompareAtPrice,
            setQtyAvailable: setQtyAvailable,
            setSale: setSale,
            setSelectAnOption: setSelectAnOption,
            setSku: setSku,
            setVariant: setVariant,
            setVariantByID: setVariantByID
        })
    }.call(this),
    function() {
        var $;
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Sections = function() {
            var $;
            $ = jQuery, this.constructors = {}, this.instances = [], $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this))
        }, jQuery.noConflict()((function() {
            var sections;
            (sections = new Station.Theme.Sections).register('collection', Station.Theme.CollectionSection), sections.register('collection-list', Station.Theme.CollectionListSection), sections.register('collection-template', Station.Theme.CollectionTemplateSection), sections.register('footer', Station.Theme.FooterSection), sections.register('header', Station.Theme.HeaderSection), sections.register('map', Station.Theme.MapSection), sections.register('password-template', Station.Theme.PasswordTemplateSection), sections.register('product-template', Station.Theme.ProductTemplateSection), sections.register('sidebar', Station.Theme.SidebarSection), sections.register('slideshow', Station.Theme.SlideshowSection), sections.register('video', Station.Theme.VideoSection)
        })), Station.Theme.Sections.prototype = _.assignIn({}, Station.Theme.Sections.prototype, $ = jQuery, {
            _createInstance: function(container, constructor) {
                var $container, id, instance, type;
                if (id = ($container = $(container)).attr('data-section-id'), type = $container.attr('data-section-type'), null != (constructor = constructor || this.constructors[type])) return instance = _.assignIn(new constructor(container), {
                    id: id,
                    type: type,
                    container: container
                }), this.instances.push(instance), instance
            },
            _onSectionLoad: function(evt) {
                var container, instance;
                (container = $('[data-section-id]', evt.target)[0]) && null != (instance = this._createInstance(container)) && _.isFunction(instance.onLoad) && instance.onLoad(evt)
            },
            _onSectionUnload: function(evt) {
                this.instances = _.filter(this.instances, (function(instance) {
                    var isEventInstance;
                    return (isEventInstance = instance.id === evt.detail.sectionId) && _.isFunction(instance.onUnload) && instance.onUnload(evt), !isEventInstance
                }))
            },
            _onSelect: function(evt) {
                var instance;
                null != (instance = _.find(this.instances, (function(instance) {
                    return instance.id === evt.detail.sectionId
                }))) && _.isFunction(instance.onSelect) && instance.onSelect(evt)
            },
            _onDeselect: function(evt) {
                var instance;
                null != (instance = _.find(this.instances, (function(instance) {
                    return instance.id === evt.detail.sectionId
                }))) && _.isFunction(instance.onDeselect) && instance.onDeselect(evt)
            },
            _onBlockSelect: function(evt) {
                var instance;
                null != (instance = _.find(this.instances, (function(instance) {
                    return instance.id === evt.detail.sectionId
                }))) && _.isFunction(instance.onBlockSelect) && instance.onBlockSelect(evt)
            },
            _onBlockDeselect: function(evt) {
                var instance;
                null != (instance = _.find(this.instances, (function(instance) {
                    return instance.id === evt.detail.sectionId
                }))) && _.isFunction(instance.onBlockDeselect) && instance.onBlockDeselect(evt)
            },
            register: function(type, constructor) {
                this.constructors[type] = constructor, $('[data-section-type=' + type + ']').each(function(index, container) {
                    this._createInstance(container, constructor)
                }.bind(this))
            }
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.SidebarSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.SidebarSection.prototype = _.assignIn({}, Station.Theme.SidebarSection.prototype, jQuery, {
            onSelect: function(evt) {
                Station.GrandCentral.Accordions.init(), Station.GrandCentral.NavSide.init(), Station.GrandCentral.Notify.init(), Station.GrandCentral.Tabs.init(), 'object' == typeof twttr && twttr.widgets.load()
            },
            onBlockSelect: function(evt) {
                Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        var $;
        Station.Theme = Station.Theme || {}, Station.Theme.SlideshowSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id'), this.carousel = '#gc-carousel-' + this.sectionId, this.$carousel = $(this.carousel)
            }
        }(jQuery.noConflict()), Station.Theme.SlideshowSection.prototype = _.assignIn({}, Station.Theme.SlideshowSection.prototype, $ = jQuery, {
            onLoad: function(evt) {
                Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel)
            },
            onSelect: function(evt) {
                Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel)
            },
            onBlockSelect: function(evt) {
                var $cells, $selectedCell, $selectedCellIndex;
                this.$carousel, $cells = $('.section-block', this.$carousel), $selectedCell = $('*[data-block-id="' + evt.detail.blockId + '"]', this.$carousel), $selectedCellIndex = $cells.index($selectedCell), Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel), this.$carousel.flickity('pausePlayer').flickity('select', $selectedCellIndex)
            },
            onBlockDeselect: function() {}
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.VideoSection = function($) {
            return function(container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.VideoSection.prototype = _.assignIn({}, Station.Theme.VideoSection.prototype, jQuery, {
            onLoad: function(evt) {
                Station.Theme.Base.initFitVids()
            },
            onSelect: function(evt) {
                Station.Theme.Base.initFitFids()
            }
        })
    }.call(this);